<template>
  <div>
    <p class="accent--text mb-0">{{ title }}</p>
    <v-divider class="mb-3"></v-divider>
    <v-form ref="form" @input="toggledForm">
      <div v-for="(item, i) in finalValues" :key="i">
        <v-row>
          <v-col cols="2" class="pb-0">
            <v-combobox
              :items="materials"
              v-model="item.name"
              outlined
              dense
              label="Material name"
              clearable
              :rules="[rules.required]"
            ></v-combobox>
          </v-col>
          <v-col cols="2" class="pb-0">
            <v-text-field
              v-model="item.amount"
              append-icon="mdi-percent"
              outlined
              dense
              type="number"
              label="Amount"
              clearable
              :rules="[rules.amountRule, sumRule]"
              @wheel="$event.target.blur()"
            ></v-text-field>
          </v-col>
          <v-col cols="1" align-self="center" class="pt-0">
            <v-icon color="red" @click="remove(i)">mdi-close-thick</v-icon>
          </v-col>
        </v-row>
      </div>
    </v-form>
    <div>
      <v-row class="mb-2">
        <v-col>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                @click="addFields"
                v-bind="attrs"
                v-on="on"
                >mdi-plus-circle</v-icon
              >
            </template>
            <span>Add field</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Composition",
  components: {},
  props: {
    title: String,
    values: Array,
    fillDynamic: Boolean,
    required: Boolean,
    dialogTitle: String,
    materials: Array,
  },
  computed: {},
  data: () => ({
    finalValues: [{ name: "", amount: "" }],
    rules: {
      amountRule: (value) => {
        if ((value >= 0 && value <= 100) || value == "") {
          return true;
        } else {
          return "Value should be between 0 - 100!";
        }
      },
      required: (value) => !!value || "Field is required.",
    },
  }),
  async mounted() {
    //if we are creating whole new product, then do not push material fields
    if (
      this.dialogTitle == "Add new product" ||
      this.dialogTitle == "Add new variation"
    ) {
      this.finalValues = [];
    }
    //if there are any values remove first empty field
    //and create new fields, fill them with incoming values
    if (this.values.length > 0) {
      this.finalValues = [];
      for (const item of this.values) {
        this.finalValues.push({
          name: Object.keys(item)[0],
          amount: Object.values(item)[0],
        });
      }
    }
  },

  methods: {
    toggledForm() {
      this.$emit("toggledCompositionFields");
    },
    remove(index) {
      this.finalValues.splice(index, 1);
    },
    addFields() {
      this.finalValues.push({ name: "", amount: "" });
    },
    //checks if all amount fields together are 100 or all empty
    sumRule() {
      let sum = 0;
      let emptyFields = [];

      for (let item of this.finalValues) {
        if (item.amount != "" && item.amount != null) {
          sum += parseInt(item.amount);
        }
        if (item.amount == "" || item.amount === null) {
          emptyFields.push("empty");
        }
      }
      if ((sum == 0 || sum == 100) && emptyFields.length == 0) {
        return true;
      } else if (sum == 0 && emptyFields.length == this.finalValues.length) {
        return true;
      } else {
        return "Values together should be 100 or empty!";
      }
    },
    //validates the form
    //return ok if valid
    //return bad if not valid
    validateFields() {
      if (this.$refs.form.validate()) {
        return "ok";
      } else {
        return "bad";
      }
    },
    //forms array of all fields in one composition
    getData() {
      let values = [];
      let result;
      for (let i = 0; i < this.finalValues.length; i++) {
        const element = this.finalValues[i];
        if (element.name != "") {
          values.push({ [element.name]: element.amount });
        }
      }
      if (values.length > 0) {
        result = {
          Name: this.title,
          Purpose: "Composition",
          Value: values,
        };
      } else {
        result = null;
      }
      return result;
    },
  },
};
</script>